import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common.service';
import { TransactionHistoryService } from '../services/transaction-history.service';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.css']
})
export class TransactionHistoryComponent implements OnInit {

  transactions=[]

  constructor(private transactionHistoryService : TransactionHistoryService, private common : CommonService) { }

  ngOnInit(): void {
    setTimeout(()=>{
      this.getTransactions()
    }, 100)
    
  }

  getTransactions(){
    this.common.showLoader()
    this.transactionHistoryService.getAllTransactions().subscribe((res:any)=>{
      this.common.hideLoader()
      this.transactions = res
    }, (err)=>{
      console.log(err)
      this.common.hideLoader()
    })
  }
}
